"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBotFromHeaders = isBotFromHeaders;
function isBotFromHeaders(userAgent, akamaiBotHeader, abuseInfoHeader) {
    const userAgentContainsBot = userAgent.toLowerCase().includes('bot');
    const akamaiBotHeaderGiven = akamaiBotHeader !== null && akamaiBotHeader !== '';
    const abuseInfoHeaderGiven = abuseInfoHeader !== null && abuseInfoHeader !== '';
    return akamaiBotHeaderGiven || abuseInfoHeaderGiven || userAgentContainsBot;
}
//# sourceMappingURL=is-bot-from-headers.js.map